export const SCHWAB_URL = 'https://upload.wikimedia.org/wikipedia/commons/4/4b/Charles_Schwab_Corporation_logo.svg';

export const ORION_URL =
  'https://res.cloudinary.com/hbb0rvydd/image/upload/v1708729334/logo-light-with-white-bg_wsl2cr.svg';

export const FIDELITY_URL =
  'https://res.cloudinary.com/hbb0rvydd/image/upload/v1717044701/financial_offering_logos/fidelity-investments-icon-filled-256_n0vwb6.webp';
